
export const removeRootNode = (nodes) => {
  const rootNodeId = '00000000-0000-0000-0000-000000000001';
  return nodes.filter((id) => id !== rootNodeId);
};
